import { countBy, some } from 'lodash'
import { Alias } from '../../redux/types/products'

type NamedAlias = Pick<Alias, 'name'>

export class Duplicates {
  private countByName: ReturnType<Duplicates['countByUniqueName']>

  constructor(aliases: NamedAlias[]) {
    this.countByName = this.countByUniqueName(aliases || [])
  }

  includes(alias: NamedAlias): boolean {
    return this.count(alias) > 0
  }

  isPaddedDuplicate(alias: NamedAlias): boolean {
    const nameIsNotUnique = this.key(alias) !== alias.name
    const duplicatesExist = this.count(alias) > 1

    return nameIsNotUnique && duplicatesExist
  }

  count(alias: NamedAlias): number {
    return this.countByName[this.key(alias)] || 0
  }

  none(): boolean {
    return !some(this.countByName, (count, name) => count > 1)
  }

  private countByUniqueName(aliases: NamedAlias[]) {
    return countBy(aliases, ({ name }) => this.key({ name }))
  }

  private key({ name }: { name: string }): string {
    return name.trim()
  }
}
